
import { defineComponent, onMounted, PropType } from 'vue'
import { IdfLoader } from '@invivodf/ui-kit'
import { AuthService } from '@b2ag/auth'
import { I18n } from './VAuthCallback.types'

/**
 * Reprise locale de la vue `VAuthCallback` de `@b2ag/auth`, dont l'export `./auth-views` est
 * compilé pour Vue 3 depuis la version 3.1 et n'est donc plus consommable ici. Le pendant
 * `VAuthCallbackError` était déjà local ; les deux vues le sont désormais.
 *
 * Portage à l'identique, à deux différences près : `AdnAnimatedLoading` du design system devient
 * `IdfLoader`, et les couleurs passent sur les jetons ui-kit.
 */

const redirectionErrorMessage = /Redirected when going from (.+) to (.+) via a navigation guard/

export default defineComponent({
  components: { IdfLoader },
  props: {
    targetRoute: String,
    router: {
      type: Object,
      default: () => ({
        push: () => {},
      }),
      required: true,
    },
    auth: {
      type: Object as PropType<AuthService>,
      default: () => ({
        onUserLogged: () => {
          return Promise.reject(new Error('No auth service provided'))
        },
      }),
      required: true,
    },
    i18n: {
      type: Object as PropType<I18n>,
      default: null,
    },
  },
  setup(props) {
    const { router, auth } = props
    onMounted(async () => {
      try {
        await auth.onUserLogged()
        await router.push(props.targetRoute).catch((err) => {
          if (!redirectionErrorMessage.exec(err.message ?? '')) {
            throw err
          }
        })
      } catch (error: any) {
        await router.push({
          name: 'auth-callback-error',
          params: { error_code: error.message },
        })
      }
    })
  },
})
